import React, { useEffect, useState } from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import img from "../../images/image 144.png";
import "./payment.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";

const PaymentSuccessfull = () => {
  const navigate = useNavigate();
  const [latestOrder, setLatestOrder] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await axios.get(
        `${BASE_URL}/orders/summary?userId=${userId}`
      );

      if (response.data.length > 0) {
        const sortedOrders = response.data.sort(
          (a, b) => new Date(b.billDate) - new Date(a.billDate)
        );
        setLatestOrder(sortedOrders[0]);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  return (
    <div className="payment-status-page">
      <div>
        <Header />
        <div className="payment-status-container">
          <h2>Thank You!</h2>
          <img src={img} />
          <p>
            Your Order is Placed! Our Team will Contact you for Shipping Charges
            & Payment Process! Stay Tuned!
          </p>
          {latestOrder && (
            <h5>
              <strong>Your Order Id is {latestOrder.orders[0].orderNo}</strong>{" "}
              <br />
            </h5>
          )}
          <button type="submit" onClick={() => navigate("/shop")}>
            Continue Shopping
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PaymentSuccessfull;
